import { Switch as $Switch } from '@mantine/core';
import type { SwitchProps as $SwitchProps } from '@mantine/core';
import { useController } from 'react-hook-form';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

type SwitchProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<$SwitchProps, 'value' | 'checked' | 'defaultValue'>;

export function Switch<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  ...props
}: SwitchProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ref: _fieldRef, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <$Switch
      checked={value}
      color="gigi-apple-pink"
      error={fieldState.error?.message}
      value={value}
      onChange={(e) => {
        fieldOnChange(e);
        onChange?.(e);
      }}
      {...field}
      {...props}
    />
  );
}
